/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReceiptSettlementExchangeRateResponseDto
 */
export interface ReceiptSettlementExchangeRateResponseDto {
    /**
     * Original currency code
     * @type {string}
     * @memberof ReceiptSettlementExchangeRateResponseDto
     */
    originalCurrency: string;
    /**
     * Settlement exchange rate
     * @type {string}
     * @memberof ReceiptSettlementExchangeRateResponseDto
     */
    settlementExchangeRate: string;
    /**
     * Receipt ID
     * @type {number}
     * @memberof ReceiptSettlementExchangeRateResponseDto
     */
    receiptId: number;
    /**
     * Created date
     * @type {Date}
     * @memberof ReceiptSettlementExchangeRateResponseDto
     */
    createdAt: Date;
    /**
     * Updated date
     * @type {Date}
     * @memberof ReceiptSettlementExchangeRateResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the ReceiptSettlementExchangeRateResponseDto interface.
 */
export function instanceOfReceiptSettlementExchangeRateResponseDto(value: object): value is ReceiptSettlementExchangeRateResponseDto {
    if (!('originalCurrency' in value) || value['originalCurrency'] === undefined) return false;
    if (!('settlementExchangeRate' in value) || value['settlementExchangeRate'] === undefined) return false;
    if (!('receiptId' in value) || value['receiptId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ReceiptSettlementExchangeRateResponseDtoFromJSON(json: any): ReceiptSettlementExchangeRateResponseDto {
    return ReceiptSettlementExchangeRateResponseDtoFromJSONTyped(json, false);
}

export function ReceiptSettlementExchangeRateResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceiptSettlementExchangeRateResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'originalCurrency': json['originalCurrency'],
        'settlementExchangeRate': json['settlementExchangeRate'],
        'receiptId': json['receiptId'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ReceiptSettlementExchangeRateResponseDtoToJSON(json: any): ReceiptSettlementExchangeRateResponseDto {
    return ReceiptSettlementExchangeRateResponseDtoToJSONTyped(json, false);
}

export function ReceiptSettlementExchangeRateResponseDtoToJSONTyped(value?: ReceiptSettlementExchangeRateResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'originalCurrency': value['originalCurrency'],
        'settlementExchangeRate': value['settlementExchangeRate'],
        'receiptId': value['receiptId'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

